<template>
  <va-edit-layout>
    <form-form :id="id" :title="title" :item="item"></form-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
